var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextStepBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 26,
    viewBox: "0 0 48 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 26,
    rx: 10,
    fill: "#AEC3DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.376 13.292H21.936V18.248H20.748V8H21.936V12.152H23.376V13.292ZM17.208 16.556C17.696 16.556 18.18 16.512 18.66 16.424C19.148 16.336 19.548 16.216 19.86 16.064V17.144C19.556 17.296 19.152 17.416 18.648 17.504C18.152 17.592 17.652 17.636 17.148 17.636H13.14V8.372H19.056V9.452H14.352V16.556H17.208ZM29.315 11.888C27.979 11.888 26.891 11.724 26.051 11.396C25.211 11.068 24.791 10.572 24.791 9.908C24.791 9.244 25.211 8.752 26.051 8.432C26.891 8.104 27.979 7.94 29.315 7.94C30.651 7.94 31.739 8.104 32.579 8.432C33.419 8.752 33.839 9.244 33.839 9.908C33.839 10.572 33.419 11.068 32.579 11.396C31.739 11.724 30.651 11.888 29.315 11.888ZM29.315 10.94C30.275 10.94 31.059 10.856 31.667 10.688C32.275 10.512 32.579 10.252 32.579 9.908C32.579 9.572 32.271 9.316 31.655 9.14C31.047 8.964 30.267 8.876 29.315 8.876C28.363 8.876 27.579 8.964 26.963 9.14C26.355 9.316 26.051 9.572 26.051 9.908C26.051 10.252 26.355 10.512 26.963 10.688C27.571 10.856 28.355 10.94 29.315 10.94ZM24.203 12.692H34.439V13.652H24.203V12.692ZM24.911 14.648H33.719V18.128H24.911V14.648ZM32.543 17.18V15.596H26.099V17.18H32.543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStepBtn);
export default __webpack_public_path__ + "static/media/nextStepBtn.deb2605842c5a7e1adaee306b85d165a.svg";
export { ForwardRef as ReactComponent };